import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { SelectItem } from './select.service';
import { ChangedItemsEvent, SelectComponent } from './select.component';
import { HubstaffOrganizationDTO } from '../../core/models/hubstaff-entities.model';

export interface ChangedOrganizationEvent {
  selectedOrganization: HubstaffOrganizationDTO[];
}

@Component({
  selector: 'app-select-organization',
  template: `<app-select
    [id]="id"
    [placeholder]="placeholder"
    [items]="items"
    [initItemIds]="initItemIds"
    (changeEvent)="handleSelectedItems($event)"
  ></app-select>`,
  imports: [SelectComponent],
})
export class SelectOrganizationComponent implements OnChanges {
  @Input() organizations: HubstaffOrganizationDTO[] = [];
  @Input() selectedOrganization?: HubstaffOrganizationDTO;
  @Output() changedorganizationEvent = new EventEmitter();
  id = 'select-organization';
  placeholder = 'Select organization';
  items: SelectItem[] = [];
  initItemIds: string[] = [];

  ngOnChanges(): void {
    if (this.selectedOrganization) {
      this.initItemIds = [this.selectedOrganization.id];
    }

    this.items = this.organizations.map(organization => {
      return {
        id: organization.id,
        text: organization.name,
      };
    });
  }

  handleSelectedItems(event: ChangedItemsEvent): void {
    const selectedOrganization = this.organizations.filter(organization => {
      return event.selectedItems.includes(organization.id);
    });

    this.changedorganizationEvent.emit({ selectedOrganization });
  }
}
